
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { 
  FeatureBase,
} from "@models";
import { 
  StartEquipmentChoice,
} from "@dndModels";
import DandDAPI from "@dndUtilities/system_api";
import { DataType } from "@dndModels/Types";

const api = DandDAPI.getInstance();

export class GameClass extends DandDFeatureSource {
  data_type: DataType = "game_class";
  feature_source_type = "GameClass";
  class_group = "";
  hit_die = 6;
  subclass_level = 1;
  subclasses_called = "Subclass";
  subclass_description = "";
  
  primary_abilities: string[] = [];
  secondary_abilities: string[] = [];
  old_start_equipment: StartEquipmentChoice[] = [];
  sidekick = false;

  constructor(obj?: any) {
    super(obj, "GameClass");
    if (obj) {
      this.class_group = obj.class_group ? obj.class_group : "";
      this.hit_die = obj.hit_die ? obj.hit_die : 6;
      this.subclass_level = obj.subclass_level ? obj.subclass_level : 1;
      this.subclasses_called = obj.subclasses_called ? obj.subclasses_called : "Subclass";
      this.subclass_description = obj.subclass_description ? obj.subclass_description : "";
      this.primary_abilities = obj.primary_abilities ? obj.primary_abilities : [];
      if (this.primary_abilities.length === 0) {
        if (obj.primary_ability) {
          switch (obj.primary_ability) {
            case "STR or DEX": this.primary_abilities = ["STR","DEX"]; break;
            case "INT, WIS, or CHA": this.primary_abilities = ["INT","WIS","CHA"]; break;
            default: this.primary_abilities = [obj.primary_ability]; break;
          }
        }
      }
      this.secondary_abilities = obj.secondary_abilities ? obj.secondary_abilities : [];
      if (this.secondary_abilities.length === 0) {
        if (obj.secondary_ability && obj.secondary_ability !== "None") {
          this.secondary_abilities = [obj.secondary_ability];
        }
      }
      if (obj.start_equipment) {
        obj.start_equipment.forEach((o: any) => {
          const choice = new StartEquipmentChoice(o);
          this.old_start_equipment.push(choice);
        });
      }
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature_base = new FeatureBase(o);
          this.feature_bases.push(feature_base);
        });
      }
      this.sidekick = obj.sidekick ? obj.sidekick : false;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.class_group = obj.class_group ? obj.class_group : "";
  //     this.hit_die = obj.hit_die ? obj.hit_die : 6;
  //     this.subclass_level = obj.subclass_level ? obj.subclass_level : 1;
  //     this.subclasses_called = obj.subclasses_called ? obj.subclasses_called : "Subclass";
  //     this.subclass_description = obj.subclass_description ? obj.subclass_description : "";
  //     this.primary_abilities = obj.primary_abilities ? obj.primary_abilities : [];
  //     if (this.primary_abilities.length === 0) {
  //       if (obj.primary_ability) {
  //         switch (obj.primary_ability) {
  //           case "STR or DEX": this.primary_abilities = ["STR","DEX"]; break;
  //           case "INT, WIS, or CHA": this.primary_abilities = ["INT","WIS","CHA"]; break;
  //           default: this.primary_abilities = [obj.primary_ability]; break;
  //         }
  //       }
  //     }
  //     this.secondary_abilities = obj.secondary_abilities ? obj.secondary_abilities : [];
  //     if (this.secondary_abilities.length === 0) {
  //       if (obj.secondary_ability && obj.secondary_ability !== "None") {
  //         this.secondary_abilities = [obj.secondary_ability];
  //       }
  //     }
  //     if (obj.start_equipment) {
  //       obj.start_equipment.forEach((o: any) => {
  //         const choice = new StartEquipmentChoice(o);
  //         this.old_start_equipment.push(choice);
  //       });
  //     }
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature_base = new FeatureBase(o);
  //         this.feature_bases.push(feature_base);
  //       });
  //     }
  //     this.sidekick = obj.sidekick ? obj.sidekick : false;
  //   }
  // }

  get primary_abilities_string(): string {
    let str = "";
    for (let i = 0; i < this.primary_abilities.length; ++i) {
      const ability = this.primary_abilities[i];
      if (i > 0) {
        str += ", ";
        if (i === this.primary_abilities.length - 1) {
          str += "or ";
        }
      }
      str += ability;
    }
    if (this.secondary_abilities.length > 0) {
      str += " and ";
      for (let i = 0; i < this.secondary_abilities.length; ++i) {
        const ability = this.secondary_abilities[i];
        if (i > 0) {
          str += ", ";
          if (i === this.secondary_abilities.length - 1) {
            str += "or ";
          }
        }
        str += ability;
      }
    }
    return str;
  }

  get sidekick_string() {
    if (this.sidekick) {
      return "Sidekick";
    }
    return "";
  }

  get_detail_format() {
    let str = super.get_detail_format();
    if (this.sidekick) {
      str += `; ${this.sidekick_string} - Hit Die: d${this.hit_die}`;
    } else {
      str += `; Hit Die: d${this.hit_die}`;
    }
    return str.trim();
  }

  get_homebrewery_string(): string {
    let str = `# ${this.true_name}\n\r`;
    str += `${this.description}\n\r`;
    str += `#### Class Group: ${this.class_group}\n\r`;
    str += `#### Primary Abilit${this.secondary_abilities.length > 0 ? "ies" : "y"}: ${this.primary_abilities_string}\n\r`;
    str += `#### Hit Dice: d${this.hit_die}\n\r`;
    str += this.get_homebrewery_fbs_string();
    return str;
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      class_group: this.class_group,
      hit_die: this.hit_die,
      subclass_level: this.subclass_level,
      subclasses_called: this.subclasses_called,
      subclass_description: this.subclass_description,
      primary_abilities: this.primary_abilities,
      secondary_abilities: this.secondary_abilities,
      sidekick: this.sidekick,
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      class_group: this.class_group,
      hit_die: this.hit_die,
      subclass_level: this.subclass_level,
      subclasses_called: this.subclasses_called,
      subclass_description: this.subclass_description,
      primary_abilities: this.primary_abilities,
      secondary_abilities: this.secondary_abilities,
      sidekick: this.sidekick,
    };
  }

  copy(copyMe: GameClass, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.class_group = copyMe.class_group;
    this.hit_die = copyMe.hit_die;
    this.subclass_level = copyMe.subclass_level;
    this.subclasses_called = copyMe.subclasses_called;
    this.subclass_description = copyMe.subclass_description;
    this.feature_bases = [];
    copyMe.feature_bases.forEach(fb => {
      this.feature_bases.push(fb.clone(drop_ids));
    });
    this.primary_abilities = [...copyMe.primary_abilities];
    this.secondary_abilities = [...copyMe.secondary_abilities];
    this.old_start_equipment = [...copyMe.old_start_equipment];
    this.sidekick = copyMe.sidekick;
  }

  clone(drop_ids = false): GameClass {
    const new_obj = new GameClass();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy5e(copyMe: any): void {
    // console.log(copyMe);
    this.name = copyMe.name;
    this.hit_die = copyMe.hit_die;
    this.subclass_level = 3;
  }
}